import { render } from "./BadgesSection.vue?vue&type=template&id=2fa75d72&scoped=true"
import script from "./BadgesSection.vue?vue&type=script&lang=js"
export * from "./BadgesSection.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2fa75d72"

export default script